module.exports = __webpack_public_path__ + "static/img/top.fb94540f.png";